import { createAsyncThunk } from '@reduxjs/toolkit';

import request from '../../modules/Request/request';

export const getCustomFilterViewList = createAsyncThunk(
  'getCustomFilterViewList',
  async (object, { rejectWithValue }) => {
    const response = await request('/custom-filter-view-list', { method: 'GET' });
    if (response.success) {
      return response.data;
    }
    const error = response.error && response.error.message ? response.error.message : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);

export const setCustomFilterView = createAsyncThunk(
  'setCustomFilterView',
  async (data, { rejectWithValue }) => {
    const response = await request('/custom-filter-view', {
      method: 'POST',
      body: data,
    });
    if (response.success) {
      return response.data;
    }
    const error = response.error && response.error.message ? response.error.message : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);

export const deleteCustomFilterView = createAsyncThunk('deleteCustomFilterView', async ({ id }, { rejectWithValue }) => {
  const response = await request('/delete-custom-filter-view', { method: 'DELETE', params: [id] });
  if (response.success) {
    return response.data;
  }
  const error = response.error?.message || response.error;
  throw rejectWithValue(error || 'Something went wrong');
});
